// Manila-time display helpers. Storage is UTC; we show Asia/Manila.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Photos may be full links (seed/imported) or our own /api/files/... paths.
export function photoUrl(src) {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
}

export function manilaDateTime(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-PH", {
      timeZone: "Asia/Manila",
      month: "short", day: "numeric",
      hour: "numeric", minute: "2-digit",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function manilaDate(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-PH", {
      timeZone: "Asia/Manila", month: "short", day: "numeric", year: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
